import { render, staticRenderFns } from "./NuovaTerapiaCliente.vue?vue&type=template&id=e8a1e9f0&"
import script from "./NuovaTerapiaCliente.vue?vue&type=script&lang=js&"
export * from "./NuovaTerapiaCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports